<div class="modal-header" cdkDrag cdkDragRootElement=".modal-content" cdkDragHandle>
  <h5 class="modal-title">Select Supplier</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">
  <div class="mb-3">
    <label class="form-label fw-semibold">Supplier</label>
    <select class="form-select" [(ngModel)]="supplierId">
      <option *ngFor="let supplier of supplierList" [value]="supplier.id">{{supplier.name}}</option>
    </select>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-success"
    [disabled]="supplierId == null"
    (click)="setSupplier()">Save</button>
</div>